import CategoryPageContext from '@/context/CategoryPageContext';
import { Button } from '@pwskills/rachnaui';
import { useContext, useState } from 'react';
import LeadCapture from '../../common/LeadCapture';
import { LeadCaptureEnquiryType, LeadCaptureType } from '../../../interfaces/leadCapture.enum';

const DownloadReport = ({ reportLink }: { reportLink: string }) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { categoryDetails } = useContext(CategoryPageContext);

  const [animate, setAnimate] = useState(false);
  const [animationDirection, setAnimationDirection] = useState('');

  const handleMouseEnter = () => {
    setAnimationDirection('left-to-right');
    setAnimate(true);
  };

  const handleMouseLeave = () => {
    setAnimationDirection('right-to-left');
    setAnimate(true);
  };

  const handleAnimationEnd = () => {
    setAnimate(false);
  };

  return (
    <div className="flex flex-row justify-center pt-[32px] medium:pt-[36px]">
      <Button
        variant="primary"
        className={`glitter rounded-[56px] px-[28px] hover:scale-110 ${
          animate
            ? animationDirection === 'left-to-right'
              ? 'animate-glitter-left-to-right'
              : 'animate-glitter-right-to-left'
            : ''
        }`}
        onClick={() => setOpenModal(true)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onAnimationEnd={handleAnimationEnd}
      >
        Download Report <i />
      </Button>
      {openModal && (
        <LeadCapture
          leadCaptureType={LeadCaptureType.MODAL}
          categoryId={categoryDetails?._id}
          categoryName={categoryDetails?.title}
          modelOpen={openModal}
          setModelOpen={setOpenModal}
          buttonText="Download"
          img="/images/courseDescription/course-curriculum.svg"
          msgLineOne="Your file is now started downloading"
          type="download_placement_report"
          reportLink={reportLink}
          enquiryType={LeadCaptureEnquiryType.DOWNLOAD_PLACEMENT_REPORT}
          enquiryTypeNPF="Download Placement Report"
          pageName="category_page"
          sourceName="category_download_report"
        />
      )}
    </div>
  );
};

export default DownloadReport;
